
import { mapActions, mapGetters, mapState } from 'vuex';
import Message from '../node-components/Message.vue';

export default {
  components: {
    Message,
  },
  computed: {
    ...mapState('chatbotStore', ['showNudge', 'openState', 'compactNudgeVisible']),
    ...mapGetters('chatbotStore', {
      conversation: 'getTriggeredConversation',
      currentConversationId: 'currentConversationId',
    }),
  },
  methods: {
    ...mapActions('chatbotStore', [
      'goToAmp',
      'setAmpSetupOptions',
      'setCompactNudgeVisible',
      'setNudgeState',
      'setOpenState',
      'setTriggeredConversation',
    ]),
    onNudgeClick() {
      this.setNudgeState(false);
      this.setCompactNudgeVisible(false);

      const { ampId, id: conversationId } = this.conversation || {};
      const changeConversationEvent = {
        conversationId,
        prevConversationId: this.currentConversationId || '',
        changeEvent: 'NUDGE',
      };

      this.setOpenState(true);
      if (this.currentAmpId !== ampId) {
        this.setAmpSetupOptions({ conversationId, ampId });
        this.goToAmp(ampId);
      } else {
        this.$chatbotService.runConversation(conversationId);
      }

      this.setTriggeredConversation(null);
      this.$tracking?.sendResponseEvent('conversationChange', changeConversationEvent);
    },
    dismissNudge() {
      this.setCompactNudgeVisible(false);
      this.setNudgeState(false);
    },
  },
};
